import React, { useEffect, useState } from "react";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import AssignmentIcon from "@mui/icons-material/Assignment";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { orange } from "@material-ui/core/colors";
import { UtilsService, VendorRegisService } from "src/services";
import { userStorage } from "src/common/Storage";
import { makeStyles } from "@material-ui/styles";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  textNotification: {
    color: "#72828A",
    fontSize: 20,
    paddingLeft: 5,
    borderColor: "#E0E3E7",
    maxWidth: 260,
  },
}));
const ColorIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText("#c1c1c1"),
  backgroundColor: "#c1c1c1",
  "&:hover": {
    backgroundColor: "#a7a4a4",
  },
}));
const BadgeX = () => {
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [notification, setNotification] = useState([]);
  const [currentForm, setCurrentForm] = useState({});
  const open = Boolean(anchorEl);
  const userInfo = userStorage.getUser();
  const userProfile = userInfo?.userProfile || {};

  useEffect(() => {
    UtilsService.GetNotifications(userProfile.vatRegistrationNo || "").then((resp) => {
      setNotification(resp);
    }).catch(() => { });

    VendorRegisService.getCurrentForm().then((resp) => {
      setCurrentForm(resp);
    });
  }, []);

  const handleClick = (event) => {
    if (notification.length > 0) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickNotification = (event) => {
    history.push({
      pathname: "/VendorSelfAssessment",
      state: {
        vendor: 0,
        main: currentForm.mainVersionID,
        sub: currentForm.subVersionID,
        type: "SelfAssessment_V",
      },
    });
    setAnchorEl(null);
  };

  if (userProfile.roleCode === "VENDOR")
    return (
      <div>
        <Button
          id="bell-button"
          aria-controls={open ? "bell-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          {notification.length > 0 ? (
            <Badge variant="dot" color="primary" overlap="circular">
              <NotificationsNoneOutlinedIcon color="action" />
            </Badge>
          ) : (
            <NotificationsNoneOutlinedIcon color="action" />
          )}
        </Button>

        <Menu
          id="bell-menu"
          aria-labelledby="bell-button"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Stack direction="row" spacing={0}>
            <MenuItem
              sx={{
                paddingRight: "5px",
                "&:hover": { backgroundColor: "white" },
              }}
              onClick={handleClose}
            >
              <h1 style={{ fontSize: "28px", color: "#595a5a" }}>แจ้งเตือน</h1>
            </MenuItem>
            <AccessTimeFilledIcon sx={{ color: orange[500], marginTop: 1 }} size="small" />
          </Stack>
          <Divider />
          {notification.map((value, i) => {
            return (
              <div key={i}>
                <MenuItem onClick={handleClickNotification} style={{ whiteSpace: 'normal' }}>
                  <ColorIconButton
                    sx={{
                      color: "#c1c1c1",
                      backgroundColor: "#c1c1c1",
                      marginRight: "10px",
                    }}
                    size="small">
                    <AssignmentIcon sx={{ color: "white" }} />
                  </ColorIconButton>
                  <span className={classes.textNotification}>
                    {value.title}
                  </span>
                </MenuItem>
                {i < notification.length - 1 ? <Divider /> : ""}
              </div>
            );
          })}
        </Menu>
      </div>
    );

  return (
    <div>
      <Button>
        <NotificationsNoneOutlinedIcon color="action" />
      </Button>
    </div>
  );
};

export default BadgeX;
